export const HELP_ELEMENT_CLASS_NAME = 'help-uilib-o-column';
export const SLOT_MAP: {
	[key: string]: string;
} = {
	first: '1',
	second: '2',
	third: '3',
	fourth: '4',
	fifth: '5',
	sixth: '6',
	seventh: '7',
	eighth: '8',
	ninth: '9',
	tenth: '10',
};

export {
	LAYOUT_MAP,
	PAGE_TOKEN_NAME_CATEGORY,
	PAGE_TYPES,
} from 'integration/data/core/constants/layout';

export const PAGE_TOKEN_NAME_PRODUCT = 'ProductToken';
